import React, { useMemo } from 'react'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useSelector } from 'react-redux'
import { NavigationContainer } from '@src/screens/Common/containers'
import { StyleService, useStyleSheet } from '@src/style/service'
import { notificationInboxUnreadCountSelector } from '@src/selectors/notifications'
import { NotificationInboxHeaderTitle } from './NotificationInboxHeaderTitle'
import { NotificationInboxMoreMenu } from './NotificationInboxMoreMenu'

interface NotificationInboxContainerProps {
  children: React.ReactNode
  onMarkAllAsReadPress: () => void
  loading: boolean
}

export const NotificationInboxContainer = ({
  children,
  onMarkAllAsReadPress,
  loading,
}: NotificationInboxContainerProps) => {
  const styles = useStyleSheet(themedStyles)
  const unreadCount = useSelector(notificationInboxUnreadCountSelector)

  const headerTitle = useMemo(() => <NotificationInboxHeaderTitle unreadCount={unreadCount} />, [
    unreadCount,
  ])
  const rightAccessories = useMemo(
    () => [
      <NotificationInboxMoreMenu
        key="inbox-more-menu"
        onMarkAllAsReadPress={onMarkAllAsReadPress}
        isMarkAllAsReadDisabled={loading || unreadCount === 0}
      />,
    ],
    [loading, onMarkAllAsReadPress, unreadCount],
  )

  return (
    <NavigationContainer
      title={headerTitle}
      rightAccessories={rightAccessories}
      navigationBarProps={styles.navigationContainer}
      style={styles.navigationContainer}
    >
      <SafeAreaView style={styles.container} edges={['bottom']}>
        {children}
      </SafeAreaView>
    </NavigationContainer>
  )
}

const themedStyles = StyleService.create({
  navigationContainer: {
    backgroundColor: 'theme.surface.base3',
  },
  container: {
    flex: 1,
  },
})
